/* eslint-disable no-param-reassign */
import { createReducer } from '@reduxjs/toolkit';
import {
  resetPrepare,
  setMapLayerConfig,
  updateIs3dEnabled,
} from './map-settings.actions';
import { LayerConfig } from './map-settings.models';

interface PrepareState {
  is3dEnabled: boolean;
  layerSettings: LayerConfig;
}

const initialState: PrepareState = {
  is3dEnabled: false,
  layerSettings: {},
};

// eslint-disable-next-line import/prefer-default-export
export const reducer = createReducer(initialState, (builder) => {
  builder.addCase(updateIs3dEnabled, (state, action) => {
    state.is3dEnabled = action.payload;
  });

  builder.addCase(setMapLayerConfig, (state, action) => {
    state.layerSettings = action.payload;
  });

  builder.addCase(resetPrepare, (state) => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    state = initialState;
  });
});
